import React from 'react'
import { useTheme } from '../../../app/hooks/useTheme'

const MoonIcon = () => (
    <svg width='20' height='20' color='#a1a5b7' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z'
            fill='currentColor'
        />
    </svg>
)

const SunIcon = () => (
    <svg width='20' height='20' color='#f8f402' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='12' cy='12' r='4' fill='currentColor' />
        <path
            d='M12 2v2m0 16v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M2 12h2m16 0h2M4.22 19.78l1.42-1.42M17.66 6.34l1.42-1.42'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
        />
    </svg>
)

const ThemeToggle = () => {
    const { mode, toggleMode } = useTheme()

    return (
        <div
            onClick={toggleMode}
            title={mode === 'light' ? 'Dark moda geç' : 'Light moda geç'}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', lineHeight: 1 }}
        >
            {mode === 'light' ? <MoonIcon /> : <SunIcon />}
        </div>
    )
}

export default ThemeToggle
